import { useEffect, useState } from 'react';
import goodNewsService from '../services/goodNewsService';

export default function useGoodNews(menuName) {
    const [goodNews, setGoodNews] = useState([]);

    const fetchGoodNews = async () => {
        try {
            const response = await goodNewsService.getGoodNews({
                num: 3,
                language: 'de',
            });
            setGoodNews(response.data);
        } catch (error) {
            console.error('Error fetching good news:', error);
        }
    };

    useEffect(() => {
        if (menuName === 'goodnews') {
            fetchGoodNews();
        }
    }, []);

    return { goodNews };
}
